import React, { useState, Fragment } from "react";
import goldenStar from "../../images/newHome/golden_star.png"
import whiteStar from "../../images/newHome/white_star.png"
import client1Image from "../../images/newHome/lulu_meyers.png"
import leftArrowSvg from "../../images/newHome/testiomonial_carousel_left_arrow.png"
import rightArrowSvg from "../../images/newHome/testiomonial_carousel_right_arrow.png"
import client2Image from "../../images/newHome/contact.png"

function TestimonialSection() {
    const clientList = [
        {
            rating: 5,
            content: "Telcron has saved us thousands hours of work. We're able to spin up projects and features faster.",
            name: "Lulu Meyers",
            shortDsg: "HourGlass",
            designation: "PM, HourGlass",
            company: "Web Design Agency",
            image: client1Image
        },
        {
            rating: 3,
            content: "Telcron has saved us thousands hours of work.",
            name: "Rich johnson",
            shortDsg: "Tech Mania",
            designation: "CEO, Tech Mania",
            company: "Web Dev Agency",
            image: client2Image
        },
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(true);

    const handleChange = (direction: any) => {
        setFade(false); // Trigger fade out
        setTimeout(() => {
            setCurrentIndex((prev) => {
                const newIndex = direction === "next"
                    ? (prev + 1) % clientList.length
                    : (prev - 1 + clientList.length) % clientList.length;
                return newIndex;
            });
            setFade(true); // Trigger fade in
        }, 200); // matches transition duration
    };

    const current = clientList[currentIndex];

    return (
        <Fragment>
            <div className="container lg:p-20 px-0">
                <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-16">
                    {/* Left Section */}
                    <div className="flex flex-col justify-center m-4 lg:m-8 xl:m-8" style={{ opacity: fade ? 1 : 0 }}>
                        <div className="min-h-[320px] max-h-[550px]">
                            <div className="flex mb-8">
                                {[...Array(current.rating)].map((_, index) => (
                                    <img key={index} className="px-0.5" src={goldenStar} alt="star" />
                                ))}
                            </div>
                            <h1
                                className="font-bold txt-titleColor text-[32px] xl:text-[44px] leading-[40px] xl:leading-[50px]
                                overflow-hidden text-ellipsis break-words"
                                style={{
                                    display: '-webkit-box',
                                    WebkitLineClamp: 10,
                                    WebkitBoxOrient: 'vertical',
                                    maxHeight: '500px',
                                }}
                            >
                                {current.content}
                            </h1>
                        </div>
                        <div className="flex justify-between md:mt-12 mt-5">
                            <div>
                                <p className="text-lg text-titleColor font-semibold">{current.name}</p>
                                <span className="text-base text-gray-500">{current.shortDsg}</span>
                            </div>
                            <div className="flex gap-8">
                                <img onClick={() => handleChange("prev")} className="w-[56px] cursor-pointer" src={leftArrowSvg} alt="Left" />
                                <img onClick={() => handleChange("next")} className="w-[56px] cursor-pointer" src={rightArrowSvg} alt="Right" />
                            </div>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="xl:w-[576px] xl:h-[720px] w-full relative overflow-hidden" style={{ opacity: fade ? 1 : 0 }}>
                        <img className="w-full h-full object-cover" src={current.image} alt={current.name} />

                        {/* Glass overlay */}
                        <div className="absolute bottom-0 w-full lg:p-8 p-5 bg-white/15 backdrop-blur-md text-white">
                            <div className="flex items-start justify-between">
                                <div>
                                    <div className="py-5">
                                        <p className="lg:text-[28px] xl:text-[48px] text-[32px] text-white font-semibold">{current.name}</p>
                                    </div>
                                    <div className="flex flex-col">
                                        <span className="text-lg font-medium">{current.designation}</span>
                                        <span className="text-base">{current.company}</span>
                                    </div>
                                </div>
                                <div className="flex">
                                    {[...Array(current.rating)].map((_, index) => (
                                        <img key={index} className="px-0.5" src={whiteStar} alt="star" />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default TestimonialSection;
